import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import type { Options } from 'src/pages/transport/products/schema';
import { getProductsDetailSchema } from 'src/pages/transport/products/schema';

export function useUploadedProductsDetailParams({ calculation }: Options) {
  return usePageParamsFromSchema(getProductsDetailSchema({ calculation }), {
    filters: { underlyingData: { label: 'Underlying Data' } },
  });
}

export type PageParams = ReturnType<typeof useUploadedProductsDetailParams>;
